"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _axios = _interopRequireDefault(require("axios"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var _default = function _default() {
  var playerTool = null;
  /**
   * 请求audio数据，进行缓存
   */

  var preFetchAudio = function preFetchAudio(url) {
    return new Promise(function (resolve, reject) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (url) {
                  (0, _axios.default)({
                    url: url,
                    responseType: 'blob',
                    timeout: 120000
                  }).then(function (res) {
                    var blobUrl = window.URL.createObjectURL(res.data);
                    resolve(blobUrl);
                  }).catch(function (e) {
                    reject(e);
                  });
                } else {
                  reject();
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    });
  };
  /**
   * 设置播放工具
   * @param tool
   */


  var setPlayTool = function setPlayTool(tool) {
    playerTool = tool;
  };
  /**
   * 点选播放
   * @param range
   */


  var openAreaSelectionPlay = function openAreaSelectionPlay(range, params, playMode) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _playerTool, state;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _playerTool = playerTool, state = _playerTool.state;
              console.log("openAreaSelectionPlay ".concat(state));

              if (!(state === 'prepare' || state == 'destroyed')) {
                _context4.next = 7;
                break;
              }

              _context4.next = 5;
              return playerTool.prepare(params).then(function () {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                  return _regenerator.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return androidChangePlayMode(playMode);

                        case 2:
                          playerTool.start(range, params);

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));
              });

            case 5:
              _context4.next = 13;
              break;

            case 7:
              if (!(state === 'stop' || state === 'start' || state === 'continue')) {
                _context4.next = 12;
                break;
              }

              _context4.next = 10;
              return playerTool.setConfParams(params).then(function (res) {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
                  return _regenerator.default.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return androidChangePlayMode(playMode);

                        case 2:
                          res && playerTool.start(range, params);

                        case 3:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
              });

            case 10:
              _context4.next = 13;
              break;

            case 12:
              if (state === 'pause') {
                playerTool.continue(range, params);
              }

            case 13:
              return _context4.abrupt("return", playerTool.state);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };
  /**
   * AB选段播放
   * @param range
   * @param params
   * @param playState
   */


  var closeAreaSelectionPlay = function closeAreaSelectionPlay(range, params, playState) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              console.log("closeAreaSelectionPlay ".concat(playState));

              if (!(playState === 'prepare' || playState == 'destroyed')) {
                _context6.next = 6;
                break;
              }

              _context6.next = 4;
              return playerTool.prepare(params);

            case 4:
              _context6.next = 17;
              break;

            case 6:
              if (!(playState === 'start')) {
                _context6.next = 11;
                break;
              }

              _context6.next = 9;
              return playerTool.setConfParams(params).then(function (res) {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
                  return _regenerator.default.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          res && playerTool.prepare(params).then(function () {
                            playerTool.start(range, params);
                          });

                        case 1:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));
              });

            case 9:
              _context6.next = 17;
              break;

            case 11:
              if (!(playState === 'stop')) {
                _context6.next = 16;
                break;
              }

              _context6.next = 14;
              return playerTool.setConfParams(params).then(function (res) {
                res && playerTool.stop();
              });

            case 14:
              _context6.next = 17;
              break;

            case 16:
              if (playState === 'pause') {
                playerTool.pause();
              } else if (playState === 'continue') {
                playerTool.continue(null, params);
              }

            case 17:
              return _context6.abrupt("return", playerTool.state);

            case 18:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
  };
  /**
   * 点击播放
   * @param state
   * @param params
   */


  var clickPlay = function clickPlay(state, params, callHandler) {
    console.log("clickPlay ".concat(state));

    switch (state) {
      case 'start':
        playerTool.prepare(params).then(function () {
          playerTool.start([0], params);
          callHandler && callHandler(state);
        });
        break;

      case 'pause':
        playerTool.pause();
        callHandler && callHandler(state);
        break;

      case 'continue':
        playerTool.continue(null, params);
        callHandler && callHandler(state);
        break;

      case 'stop':
        playerTool.stop();
        callHandler && callHandler(state);
        break;

      default:
        break;
    }
  };

  var androidChangePlayMode = function androidChangePlayMode(playModeVal) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee7() {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (window.WebViewJavascriptBridge) {
                if (playModeVal === 'midi') {
                  changeSynthManagerPlayMode(0);
                } else if (playModeVal === 'rollCall') {
                  changeSynthManagerPlayMode(1);
                }
              }

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
  }; // 改变midi播放模式


  var changeSynthManagerPlayMode = function changeSynthManagerPlayMode(playMode) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee8() {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return playerTool.setPlayMode(playMode);

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
  }; // 安卓回调事件


  var playerCallBack = function playerCallBack(callbackEventStr) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee9() {
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return playerTool.playerCallBack(callbackEventStr);

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));
  }; // 清空重置FluidSynthJs


  var destroyFluidSynthJs = function destroyFluidSynthJs() {
    playerTool.destroyFluidSynthJs();
  };

  return {
    preFetchAudio: preFetchAudio,
    setPlayTool: setPlayTool,
    openAreaSelectionPlay: openAreaSelectionPlay,
    closeAreaSelectionPlay: closeAreaSelectionPlay,
    clickPlay: clickPlay,
    changeSynthManagerPlayMode: changeSynthManagerPlayMode,
    playerCallBack: playerCallBack,
    destroyFluidSynthJs: destroyFluidSynthJs
  };
};

exports.default = _default;